import { connect } from 'react-redux';
import DataMapelDiv from '../../views/Settings/DataMapelDiv.view';
import {getSubjectOptions, getParamOptions,getClassesOptions, getParamOptionsAcademics, getPrmLevels, getPeriodsOptions} from '../../states/thunks/options.thunk';
import { listKodeMatpel, deleteKodeMatpel, deleteMapelDiv, listMapelDiv} from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    result: state.result,
    user: state.user || {},
  }
}

function mapDispatchToProps(dispatch) {
  return {
      getParamOptions: (payload, type) => dispatch(getParamOptions(payload, type)),
      getSubjectOptions: (payload) => dispatch(getSubjectOptions(payload)),
      handleDeleteSubjectDetail: (payload, goback) => dispatch(deleteKodeMatpel(payload, goback)),
      getClassesOptions: (payload) => dispatch(getClassesOptions(payload)),
      getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
      getPrmLevels: (payload) => dispatch(getPrmLevels(payload)),
      getPeriodsOptions: (payload) => dispatch(getPeriodsOptions(payload)),
      handleListMapelDiv: (payload, goBack) => dispatch(listMapelDiv(payload, goBack)),
      handleDeleteMapelDiv: (payload, goBack) => dispatch(deleteMapelDiv(payload, goBack)),
  
};
}

export default connect(mapStateToProps, mapDispatchToProps)(DataMapelDiv);
